import Form from 'antd/es/form';
import { useUnit } from 'effector-react/effector-react.mjs';
import { Button, Col, Row, Select, Tooltip, TreeSelect } from 'antd';
import { ClearOutlined, FilterOutlined } from '@ant-design/icons';
import React, { useEffect } from 'react';
import {
  $activitiesTreeSelect,
  $districtsSelect,
} from '../../../models/globalModel/index.js';
import { months_dictionary } from '../../../dictionaries/months_dictionary.js';
import {
  $analyticsDistricts,
  $analyticsKrp,
  $analyticsLastDate,
  $analyticsRegions,
  applyAnalyticsFiltersEv,
  legalTypeSelect,
  resetAnalyticsFiltersEv,
} from '../../../models/organizationsModel/index.js';

const { SHOW_PARENT } = TreeSelect;

const yearOptions = [
  {
    label: 2021,
    value: 2021,
  },
  {
    label: 2022,
    value: 2022,
  },
  {
    label: 2023,
    value: 2023,
  },
  {
    label: 2024,
    value: 2024,
  },
  {
    label: 2025,
    value: 2025,
  },
];
const monthOptions = Object.keys(months_dictionary).map((key) => {
  return {
    label: months_dictionary[key],
    value: key,
  };
});
const cut_options = [
  {
    label: 'Месяц',
    value: 'month',
  },
  {
    label: 'Квартал',
    value: 'quarter',
  },
  {
    label: 'Год',
    value: 'year',
  },
];
const status_options = [
  {
    label: 'Зарегистрированный',
    value: 'registered',
  },
  {
    label: 'Действующий',
    value: 'active',
  },
];

function AnalyticsFilters() {
  const [filterForm] = Form.useForm();
  const okedTree = useUnit($activitiesTreeSelect);
  const apply = useUnit(applyAnalyticsFiltersEv);
  const reset = useUnit(resetAnalyticsFiltersEv);
  const regions = useUnit($analyticsRegions);
  const districts = useUnit($analyticsDistricts);
  const krpSelect = useUnit($analyticsKrp);
  const analyticsLastDate = useUnit($analyticsLastDate);

  const onActivitySelect = (value, label, extra) => {
    const payloadValue = [];

    const getOkedIds = (node) => {
      if (!payloadValue.includes(node.node.props.value)) {
        payloadValue.push(node.node.props.value);
      }
      if (node.children.length > 0) {
        node.children.forEach((child) => getOkedIds(child));
      }
    };

    if (extra.allCheckedNodes.length > 0) {
      extra.allCheckedNodes.forEach((checkedNode) => {
        getOkedIds(checkedNode);
      });
    }
    filterForm.setFieldValue('activity_ids', payloadValue);
  };

  const onFinish = (values) => {
    apply(values);
  };

  const onCancel = () => {
    filterForm.resetFields();
    reset();
  };

  useEffect(() => {
    if (analyticsLastDate) {
      filterForm.setFieldsValue({
        month: analyticsLastDate.date.slice(6, 7),
        year: analyticsLastDate.date.slice(0, 4),
      });
    }
  }, [analyticsLastDate]);

  return (
    <Form form={filterForm} onFinish={onFinish} layout="vertical">
      <Row justify="space-between" style={{ alignItems: 'center' }}>
        <Col span={2}>
          <Form.Item name="region" label="Регион">
            <Select
              options={regions}
              dropdownStyle={{ width: 300 }}
              allowClear
              showSearch
              mode="multiple"
              maxTagCount="responsive"
            />
          </Form.Item>
        </Col>
        <Col span={2}>
          <Form.Item name="district" label="Район">
            <Select
              options={districts}
              dropdownStyle={{ width: 300 }}
              allowClear
              showSearch
              mode="multiple"
              maxTagCount="responsive"
            />
          </Form.Item>
        </Col>
        <Col span={2}>
          <Form.Item name="activity_ids" label="ОКЭД">
            <TreeSelect
              treeData={okedTree}
              showSearch
              treeNodeFilterProp="title"
              allowClear
              style={{
                maxHeight: 32,
                overflow: 'auto',
              }}
              dropdownStyle={{ width: 500 }}
              listHeight={600}
              onChange={onActivitySelect}
              // treeCheckable
              showCheckedStrategy={SHOW_PARENT}
              multiple
              maxTagCount="responsive"
            />
          </Form.Item>
        </Col>
        <Col span={2}>
          <Form.Item name="krp" label="КРП">
            <Select
              options={krpSelect}
              dropdownStyle={{ width: 300 }}
              allowClear
              showSearch
              mode="multiple"
              maxTagCount="responsive"
            />
          </Form.Item>
        </Col>
        {/* <Col span={2}> */}
        {/*  <Form.Item name="legal_type" label="Юридический тип"> */}
        {/*    <Select */}
        {/*      options={legalTypeSelect} */}
        {/*      dropdownStyle={{ width: 300 }} */}
        {/*      allowClear */}
        {/*      showSearch */}
        {/*    /> */}
        {/*  </Form.Item> */}
        {/* </Col> */}
        <Col span={2}>
          <Form.Item name="cut" label="Срез">
            <Select
              options={cut_options}
              dropdownStyle={{ width: 300 }}
              allowClear
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={2}>
          <Form.Item name="status" label="Статус">
            <Select
              options={status_options}
              dropdownStyle={{ width: 300 }}
              allowClear
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={2}>
          <Form.Item name="month" label="Месяц">
            <Select
              options={monthOptions}
              dropdownStyle={{ width: 300 }}
              allowClear
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={2}>
          <Form.Item name="year" label="Год">
            <Select
              options={yearOptions}
              dropdownStyle={{ width: 300 }}
              allowClear
              showSearch
            />
          </Form.Item>
        </Col>
        <Button.Group>
          <Tooltip title="Применить фильтры">
            <Button
              onClick={() => filterForm.submit()}
              icon={<FilterOutlined />}
              type="primary"
              style={{ boxShadow: 'none' }}
            />
          </Tooltip>
          <Tooltip title="Сбросить фильтры">
            <Button onClick={onCancel} icon={<ClearOutlined />} danger />
          </Tooltip>
        </Button.Group>
      </Row>
    </Form>
  );
}

export default AnalyticsFilters;
